import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { BottomNav } from '../components/BottomNav.js';
import { DemoRibbon } from '../components/DemoRibbon.js';
import { ToastHost } from '../components/Toast.js';
import { useAuthStore } from '../stores/authStore.js';

import { bootstrapDemoIdentity, isDemoMode } from './demoBootstrap.js';

export const Shell = () => {
  const accessToken = useAuthStore((state) => state.accessToken);

  useEffect(() => {
    if (isDemoMode && !accessToken) {
      bootstrapDemoIdentity();
    }
  }, [accessToken]);

  return (
    <div className="flex min-h-full w-full justify-center md:items-center md:py-8">
      <div className="relative flex h-full min-h-[100dvh] w-full max-w-[430px] flex-col overflow-hidden bg-canvas shadow-2xl shadow-black/40 md:h-[932px] md:min-h-0 md:rounded-[44px] md:border md:border-ink/10 md:ring-8 md:ring-ink/[0.04]">
        {isDemoMode && <DemoRibbon />}
        <main className="flex-1 overflow-y-auto overflow-x-hidden">
          <Outlet />
        </main>
        <BottomNav />
        <ToastHost />
      </div>
    </div>
  );
};
